export const convertToDropDownFormat = (list) => {
  return list.map((item) => ({ label: item, value: item }));
};

export const convertAutoCompleteFormat = (list) => {
  return list.map((item) => ({ id: item, value: String(item) }));
};
